import { Content, Overlay, Portal } from '@radix-ui/react-alert-dialog'
import * as React from 'react'

import { styled } from '~/styled'

const StyledAlertDialogOverlay = styled(Overlay, {
  base: [
    'bg-alpha-600',
    'top-0',
    'right-0',
    'bottom-0',
    'left-0',
    'fixed',
    'z-1147483646',
    'motion-safe:data-[state=open]:animate-fade-in',
    'motion-safe:data-[state=closed]:animate-fade-out'
  ]
})
const StyledAlertDialogContent = styled(Content, {
  base: [
    // `transform: translate()` is required for `floating-ui` to
    // correctly position elements within the Dialog component.
    // we can't use the translate property directly
    'transform-[translate(-50%,-50%)]',
    'bg-white',
    'rounded-md',
    'shadow-xl',
    'box-border',
    'left-1/2',
    'max-w-[90vw]',
    'p-8',
    'fixed',
    'top-1/2',
    'focus:outline-none',
    'z-1147483646',
    'motion-safe:data-[state=open]:animate-slide-in-center',
    'motion-safe:data-[state=closed]:animate-slide-out-center'
  ],
  variants: {
    size: {
      sm: ['w-95'],
      md: ['w-120'],
      lg: ['w-150']
    }
  }
})

export const AlertDialogContent = ({
  size = 'sm',
  ...remainingProps
}: React.ComponentProps<typeof StyledAlertDialogContent>) => (
  <Portal>
    <StyledAlertDialogOverlay />
    <StyledAlertDialogContent size={size} {...remainingProps} />
  </Portal>
)
